import type { ReactNode } from 'react';
import { useAuth } from '@/auth/useAuth';

interface Props {
  /**
   * The code, or any one of several.
   *
   * <p>
   * Readonly is allowed so the shared lists in `permissions.ts` — which are `as const`, and so
   * readonly — can be passed straight in. Copying them at every call site to satisfy the type
   * would be the sort of thing that invites somebody to write the codes out by hand instead.
   * </p>
   */
  perm: string | readonly string[];
  children: ReactNode;
  fallback?: ReactNode;
}

/** Conditionally renders children only if the user holds (any of) the permission(s). */
export default function Can({ perm, children, fallback = null }: Props) {
  const { hasAnyPermission } = useAuth();
  const codes = Array.isArray(perm) ? perm : [perm];
  return <>{hasAnyPermission(codes) ? children : fallback}</>;
}
